import { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { useNavigate } from "@reach/router";

import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react";
import Pin3 from "../assets/images/pin3.svg";
import { useGeolocation } from "react-use";
import { Link } from "@reach/router";
import { t } from "../lang";
const MapContainer = (props) => {
  const locationState = useGeolocation();
  const { latitude, longitude } = locationState;
  const [center, setCenter] = useState({
    lat: 21.565866,
    lng: 39.139449,
  });
  const [selectedLocation, setSelectedLocation] = useState(null);
  const navigate = useNavigate();

  const userType = localStorage.getItem('userType')

  return (
    <Container>
      <TitleContainer>
      {userType === 'Individual' ? <Title>{t("Home location")}</Title>:<Title>{t("Factory location")}</Title>}
      </TitleContainer>
      <Map
        google={props.google}
        zoom={18}
        // onClick={(props, marker, e) => console.log(props, marker, e)}

        onDragend={(props, marker, e) => {
          setSelectedLocation(props.center);
          setCenter(props.center);
        }}
        initialCenter={center}
        center={center}
      >
        {/* {latitude&&  <Marker position={{lat: latitude, lng: longitude}}  onClick={() => {}} name={"Current location"} />} */}

        <InfoWindow onClose={() => {}}>
          <div>
            <h1></h1>
          </div>
        </InfoWindow>
      </Map>
      <CenterMarker>
        <CenterMarkerIcon src={Pin3} />
      </CenterMarker>
     
        <ActionsContainer
        disabled={selectedLocation==null}
          className="ActionsContainer"
          onClick={async () => {
            const config = {
              url: "https://san-api.tatweertransit.com/san/register",
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=UTF-8",
              },
              data: {
                userType: localStorage.getItem("userType"),
                industryCity: localStorage.getItem("industryCity"),
                pin: localStorage.getItem("pin"),
                mobile: localStorage.getItem("mobile"),
                latitude: selectedLocation.lat,
                longitude: selectedLocation.lng,
              },
            };


            let res = await axios(config)
            if(res.status ===200){
              localStorage.clear();
              navigate("/thankyou", { replace: true });
            }

          }}
        >
          {t("Confirm")}
        </ActionsContainer>
      
      <ZoomToMyLocationButton
        onClick={() => {
          setCenter({
            lat: latitude,
            lng: longitude,
          });
        }}
      >
        {t("My location")}
      </ZoomToMyLocationButton>
    </Container>
  );
};

const TitleContainer= styled.div`
display: inline-flex;
position: absolute;
z-index: 100;
background-color: #2099B8;
padding: 11px;
margin: 0px;
font-size:20px;
left: calc(50% - 59px);
border-radius: 0px 0px 10px 10px;
box-shadow: 0 0px 4px 0 rgb(0 0 0 / 30%);
`
const Title = styled.div`
margin: auto;
width: 100%;
display: flex;
align-items: center;
justify-content: center;

`

const ZoomToMyLocationButton = styled.div`
position: absolute;
z-index: 1000;
bottom: 26px;
left: 30px;
background-color: rgb(251, 224, 104);
height: 70px;
width: 70px;
color: #222222;
font-weight: bold;
border-radius: 82px;
display: -webkit-box;
display: -webkit-flex;
display: -ms-flexbox;
display: flex;
align-items: center;
justify-content: center;
cursor: pointer;

border: 3px solid #ffffff;
box-shadow: 0 0px 4px 0 rgba(0,0,0,0.30);
`;

const Container = styled.div``;
const ActionsContainer = styled.button`
  position: absolute;
  min-height: 71px;
  min-width: 140px;
  background-color: #182a33;
  left: calc(50% - 60px);
  bottom: 31px;
  display: flex;
  justify-content: center;
  border-radius: 60px;
  align-items: center;
  font-size: 1.3em;
  cursor: pointer;
  color: #ffffff;
  border: 0;
  &:hover {
    background: #cfb636;
    color: #182a33;
  }

  &:disabled{
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
}
`;
const CenterMarkerIcon = styled.img`
  height: 50px;
`;

const CenterMarker = styled.div`
  display: inline-flex;

  align-items: center;
  justify-content: center;
  z-index: 15;
  cursor: inherit;
  position: absolute;
  left: calc(50% - 18px);
  top: calc(50% - 47px);
`;

export default GoogleApiWrapper({
  apiKey: "AIzaSyDh_F59rHEwPXg1lnvxWKR0xtfE3b_NX1Y",
})(MapContainer);
